import React from 'react';
import {Button, Row} from 'reactstrap';

interface IRegistrationButtonsProps {
  currentStep: number;
  canGoBack?: boolean;
  handlePreviousStep: () => void;
  isLastStep?: boolean;
  updating?: boolean;
}

const RegistrationButtons: React.FC<IRegistrationButtonsProps> = ({
                                                                    currentStep,
                                                                    canGoBack = true,
                                                                    isLastStep = false,
                                                                    handlePreviousStep,
                                                                    updating = false,
                                                                  }) => {
  return (
    <Row className="d-flex justify-content-between align-items-center p-4">
      {currentStep !== 1 && canGoBack ? (
        <Button color="secondary" onClick={handlePreviousStep} className="btn-back">
          Back
        </Button>
      ) : (
        <div className="btn-placeholder"/>
      )}
      <div className="ms-auto">
        {isLastStep ? (
          <Button type="submit" color="success" className="btn-submit" disabled={updating}>
            Finish
          </Button>
        ) : (
          <Button type="submit" color="primary" className="btn-continue">
            Continue
          </Button>
        )}
      </div>
    </Row>
  );
};

export default RegistrationButtons;
